import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "@/config/firebase";

export type AuthorType = "first_book" | "memoirist" | "business_author" | "imprint";
export type PrimaryGoal = "finish_manuscript" | "publish_print" | "preserve_voice" | "build_catalog";

export interface AuthorProfileInput {
  readonly user_id: string;
  readonly display_name: string;
  readonly email: string;
  readonly author_type: AuthorType;
  readonly primary_goal: PrimaryGoal;
  readonly package_intent: string;
}

export async function upsertAuthorProfile(input: AuthorProfileInput): Promise<void> {
  await setDoc(
    doc(db, "author_profiles", input.user_id),
    {
      user_id: input.user_id,
      display_name: input.display_name,
      email: input.email,
      author_type: input.author_type,
      primary_goal: input.primary_goal,
      package_intent: input.package_intent,
      updated_at: serverTimestamp(),
    },
    { merge: true },
  );
}
